import type { EntityId } from './api/entityId';

const documentDragDataType = 'application/x-knowledgebase-document-id';

export function setDraggedDocument(event: DragEvent, documentId: EntityId): void {
  if (event.dataTransfer == null) {
    throw new Error('Drag event does not contain dataTransfer.');
  }

  event.dataTransfer.effectAllowed = 'copyMove';
  event.dataTransfer.setData(documentDragDataType, documentId);
  event.dataTransfer.setData('text/plain', documentId);
}

export function isDraggedDocument(event: DragEvent): boolean {
  return event.dataTransfer?.types.includes(documentDragDataType) === true;
}

export function getDraggedDocumentId(event: DragEvent): EntityId | null {
  if (!isDraggedDocument(event)) {
    return null;
  }

  const documentId = event.dataTransfer?.getData(documentDragDataType).trim();
  return documentId && /^\d+$/.test(documentId) ? documentId : null;
}
